import { useLocation } from "react-router-dom";
import Cookies from "./Cookies.tsx";

const CookiesWrapper = () => {
  const location = useLocation();

  if (location.pathname === "/privacy-policy") {
    return null;
  }

  return <Cookies />;
};

export default CookiesWrapper;
